define('checkPreInit/checkReporting',['atn/atn', './loadingErrors'], function(atn, errors) {
    'use strict';
    return {
        checkReporting: checkReporting
    };

    function checkReporting(data, next) {
        var urlParts = atn.utils.parseURL(window.location.href),
            isUsageReporting = urlParts.query.usage === 'reporting';
        next(isUsageReporting ? errors.FOR_REPORTING : null);
    }
});
